import React from 'react';

import css from './Folder.module.css';

import FolderTree from '../components/FolderTree';
import Details from './Details';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {
  Button,
  FormControl,
  TextField,
  Drawer,
} from '@material-ui/core';


class Folder extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      subfolder: '',
      folderPrefix: '',
      folderId: '',
      folderName: '',
      folderHash: {},
      folderReload: () => {},
      filesLoading: false,
      files: [],
      viewDetails: false,
      detailsData: {},
    };
  }

  componentDidMount = () => {

  }


  getSearchResults = (folderPrefix, page=1) => {
    return new Promise(async (resolve, reject) => {
      try {
        let params = { folder_exact: folderPrefix, page: page };
        let endpoint = `/api/search`;
        let response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(params),
        });
        let results = await response.json();
        return resolve(results);
      }
      catch(err) {
        return reject();
      }
    });
  }

  getFiles = async (folderPrefix) => {
    let page = 1;
    let result = await this.getSearchResults(folderPrefix, page);
    let files = result.items;
    let next = result.next;
    ++page;

    while(next) {
      result = await this.getSearchResults(folderPrefix, page);
      files = files.concat(result.items);
      next = result.next;
      ++page;
    }

    return files;
  }

  folderOnSelect = async (folderPrefix, folderId, folderName) => {
    if(folderId === this.state.folderId)
      return;

    this.setState({ folderPrefix: folderPrefix, folderId: folderId, folderName: folderName, files: [], filesLoading: true });
    let files = await this.getFiles(folderPrefix || '/');
    this.setState({ files: files, filesLoading: false });
  }

  folderOnInit = ({ reset, hash, reload }) => {
    this.setState({ folderReload: reload, folderHash: hash });
  }

  createFolder = (path) => {
    return new Promise(async (resolve, reject) => {
      try {
        let params = { path: path };
        let endpoint = `/api/folder`;
        let response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(params),
        });
        let results = await response.json();
        return resolve(results);
      }
      catch(err) {
        return reject();
      }
    });
  }

  handleSubfolderCreate = async (event) => {
    if(!this.state.subfolder)
      return this.props.alert('Empty Folder Name', 'Please provide a folder name');
    else if(!this.state.folderId)
      return this.props.alert('No Folder Selected', 'Please select a parent folder for the new folder');

    this.props.alert('Creating Folder', '', false);
    let noti = {
      id: `${this.state.folderId}/${this.state.subfolder}`,
      title: 'Created Folder',
      message: `Folder: ${this.state.subfolder}`,
      status: 'done',
    };
    let newFolderPath = `${this.state.folderPrefix}${this.state.subfolder}`;
    await this.createFolder(newFolderPath);
    this.props.alert('Folder Created', '', false);
    setTimeout(() => this.props.alert('', ''), 1000);
    await this.props.notiActions.add(noti);
    this.setState({ subfolder: '' });
    this.state.folderReload();
  }

  handleSubfolderChange = (event) => {
    this.setState({subfolder: event.target.value});
  }

  handleSubfolderDelete = async (event) => {
    if(!this.state.folderId)
      return this.props.alert('No Folder Selected', 'Please select a folder to delete');

    if(this.state.folderName === 'root' || this.state.folderName === '' || this.state.folderName === '/')
      return this.props.alert('Cannot Delete Root Folder', 'Please select another folder to delete');

    this.props.alert(
      'Delete Confirmation',
      `Do you want to delete folder "${this.state.folderName}" and all its contents?`,
      false,
      this.handleSubfolderDeleteConfirm
    );
  }

  handleSubfolderDeleteConfirm = async (result) => {
    if(!result)
      return this.props.alert('Delete Canceled');

    this.props.alert('Deleting Folder', 'Please wait...', false);
    let noti = {
      id: `delete/${this.state.folderId}`,
      title: 'Deleted Folder',
      message: `Folder: ${this.state.folderName}`,
      status: 'done',
    };
    let err = await this.deleteSubfolder(this.state.folderPrefix);
    if(err)
      return this.props.alert(err.title, err.message);
    this.props.alert('Folder Deleted', '', false);
    setTimeout(() => this.props.alert('', ''), 1000);
    await this.props.notiActions.add(noti);
  }

  deleteSubfolder = async (folderPrefix) => {
    if(folderPrefix === 'root' || folderPrefix === '' || folderPrefix === '/')
      return { title: 'Cannot Delete Root Folder', message: 'Please select another folder to delete' };

    await this.deleteFolder(folderPrefix);
    await new Promise((resolve, reject) => setTimeout(() => resolve(), 1000));
    this.state.folderReload();
  }

  deleteFolder = async (path) => {
    return new Promise(async (resolve, reject) => {
      try {
        let params = new URLSearchParams({ path: path });
        let endpoint = `/api/folder?${params}`;
        let response = await fetch(endpoint, {
          method: 'DELETE',
        });
        let results = await response.json();
        return resolve(results);
      }
      catch(err) {
        return reject();
      }
    });
  }

  getFileUrl = (path, action='read', preview=false) => {
    return new Promise(async (resolve, reject) => {
      try {
        let params = new URLSearchParams({ path: path, action: action, preview: preview });
        let endpoint = `/api/sasurl?${params}`;
        let response = await fetch(endpoint);
        let result = await response.json();
        return resolve(result.url);
      }
      catch(err) {
        return reject();
      }
    });
  }

  getFolderPrefix = (path) => {
    let pathParts = path.split('/').slice(0, -1);
    return pathParts.length === 0 ? 'root/' : pathParts.join('/');
  }

  toggleViewDetails = (data) => async (event) => {
    if(event.target.name === 'file-checkbox' || event.target.getAttribute('data-name') === 'file-checkbox')
      return;
    
    if(data) {
      data.downloadUrl = await this.getFileUrl(data.path);
      data.folder = this.getFolderPrefix(data.path);

      // Check if is an image or video
      let fileType = data.path.split('.').pop().toLowerCase();
      
      if(['jpeg', 'jpg', 'png', 'gif', 'svg', ''].includes(fileType)) {
        data.imageUrl = data.downloadUrl;
      } else if(['mxf', 'mp4', 'mpeg4', 'mov', 'm4v'].includes(fileType)) {
        let pathParts = data.path.split('/');
        let filenameParts = pathParts.pop().split('.');
        let thumbnailPath = `${pathParts.join('/')}/thumbnail-${filenameParts[0]}.png`;
        let previewPath = `${pathParts.join('/')}/preview-${filenameParts[0]}.mp4`;
        data.imageUrl = await this.getFileUrl(thumbnailPath, 'read', true);
        data.previewUrl = await this.getFileUrl(previewPath, 'read', true);
      }
      
      this.setState({detailsData: data, viewDetails: true});
    } else 
      this.setState({detailsData: {}, viewDetails: false});
  }

  detailsCallback = () => {
    this.setState({viewDetails: false});
  }

  deleteFile = async (path) => {
    return new Promise(async (resolve, reject) => {
      try {
        let params = new URLSearchParams({ path: path });
        let endpoint = `/api/item?${params}`;
        let response = await fetch(endpoint, {
          method: 'DELETE',
        });
        let results = await response.json();
        return resolve(results);
      } catch(err) {
        reject();
      }
    });
  }

  handleFileDelete = async (path) => {
    this.setState({viewDetails: false});
    this.props.alert('Deleting File', 'Please wait...', false);
    await this.deleteFile(path);
    this.props.alert('File Deleted', 'File has been successfully deleted');
    this.state.folderReload();
  }

  render() {
    return (
      <div style={{margin: '50px'}}>
        <Container fluid={true}>
          <Row>
            <Col>
              Folder View:
              <FolderTree onInit={this.folderOnInit} onSelect={this.folderOnSelect} />
              <br />
              <FormControl className="w-100 m-1">
                <TextField 
                  labelId="people-input-label" 
                  id="standard-basic" 
                  label="SubFolder Name" 
                  value={this.state.subfolder}
                  onChange={this.handleSubfolderChange}
                />
              </FormControl>
              <br />
              <Button onClick={this.handleSubfolderCreate}>CREATE SUBFOLDER ON CURRENTLY SELECTED FOLDER</Button>
              <Button onClick={this.handleSubfolderDelete}>DELETE CURRENTLY SELECTED FOLDER</Button>
            </Col>
            <Col>
              Files:
              {this.state.filesLoading ? <div>Loading Results...</div> : null}
              {this.state.files.length === 0 && !this.state.filesLoading ? <div>No Files in Folder</div> : null}
              {this.state.files.map((entry, index) => (
                <div key={index} className={css.file} onClick={this.toggleViewDetails(entry)}>{entry.path.split('/').pop()}</div>
              ))}
            </Col>
          </Row>
        </Container>
        <Drawer anchor={'right'} open={this.state.viewDetails} onClose={this.toggleViewDetails()}>
          <Details data={this.state.detailsData} callback={this.detailsCallback} onDelete={this.handleFileDelete} />
        </Drawer>
      </div> 
    );
  }
}

export default Folder;